import React from "react";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";
import {fetchDriversForSelect, useDriversForSelect} from "../../../../redux/users";
import {getFullName} from "./FullName";
import {CONFIG} from "../../../../_ae/config";

export const DriverField = ({...props}) => {
  const dispatch = useDispatch();
  const {data, metadata, isLoading} = useDriversForSelect()

  const HandleSearch = search => {
    dispatch(
      fetchDriversForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name='driver'
      label={CONFIG.ROLES.DRIVER}
      options={data}
      getOptionLabel={getFullName}
      onOpen={()=>{
        HandleSearch('')
      }}
      onInputChange={(event, search) => {
        HandleSearch(search)
      }}
      loading={isLoading}
      withFeedbackLabel={false}
      customFeedbackLabel={false}
      {...props}
    />
  )
}